enum VIEW_MODE {
  VIEW = "view",
  EDIT = "edit",
}

enum ENUM_VALIDATION_TYPES {
  NAME = "name",
  PASSWORD = "password",
  EMAIL = "email",
  CORPORATE_EMAIL = "corporate_email",
  URL = "url",
  LINKEDIN_URL = "linkedin_url",
  PHONE = "phone",
  POSITIVE_INTEGER_NUMBER = "positive_integer_number",
  NUMBER_WITH_DOT = "number_with_dot",
  CONFIRM_PASSWORD = "confirm_password",
  USD_CURRENCY = "usd_currency",
}

enum ENUM_FORM_INPUT_TYPES {
  TEXTFIELD = "textfield",
  SELECTBOX = "selectbox",
  MULTI_SELECTBOX = "multi_selectbox",
  CHIP_TEXT_FIELD = "chip_text_field",
  AUTO_SELECTBOX = "auto_selectbox",
  SWITCH = "switch",
}

enum ENUM_LABEL_VALUE_TYPES {
  CHIP_LIST = "chip-list",
}

enum ENUM_QUALIFY_QUESTION_TYPES {
  SHORT_TEXT = "ShortText",
  OPTION = "DropDown",
  BOOLEAN = "YesNo",
  MULTI_SELECT = "MultiSelect",
}

enum ENUM_LOOKING_FOR {
  ONE2ONE_INTRODUCTORY_SALES_MEETINGS = "ONE2ONE_INTRODUCTORY_SALES_MEETINGS",
  ONE2ONE_ADVISORY = "ONE2ONE_ADVISORY",
  INVESTORS = "INVESTORS",
  ADVISORY_BOARD_MEMBERS = "ADVISORY_BOARD_MEMBERS",
}

enum ENUM_OPPORTUNITY_FORM_MODE {
  PROFILE_EDIT = "profile_edit",
  PROFILE_INSIGHT = "profile_insight",
}

enum ENUM_INTRESTED_IN_PRIORITY_LIST {
  LOW = "low",
  MEDIUM = "medium",
  HIGH = "high",
}

export {
  VIEW_MODE,
  ENUM_VALIDATION_TYPES,
  ENUM_FORM_INPUT_TYPES,
  ENUM_LABEL_VALUE_TYPES,
  ENUM_QUALIFY_QUESTION_TYPES,
  ENUM_LOOKING_FOR,
  ENUM_OPPORTUNITY_FORM_MODE,
  ENUM_INTRESTED_IN_PRIORITY_LIST,
};
